import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import MainNavItem from 'components/MainNavItem';
import { DataStoreType } from 'models/DataStore';
import { ROUTE_FIRE } from 'utils/constants/routes';

interface FireNavItemProps {
  dataStore?: DataStoreType;
  active?: boolean;
  displayWithoutOnlyOrg?: boolean;
}

export default inject('dataStore')(
  observer(({ dataStore, active }: FireNavItemProps) => {
    if (!dataStore!.user?.org_memberships || dataStore!.isOrgViewerButNotEditor) {
      return null;
    }

    let orgId: number | undefined;

    if (dataStore!.currentOrganizationId) {
      orgId = dataStore!.currentOrganizationId;
    } else {
      orgId = dataStore!.user?.org_memberships[0].organization_id;
    }

    if (!orgId) {
      return null;
    }

    return (
      <MainNavItem
        label={<FormattedMessage id="Fire" />}
        iconName="assistant"
        active={active}
        to={ROUTE_FIRE + '/' + orgId}
      />
    );
  })
);
